import { useEffect, useState } from "react";
import { RotateCcw } from "lucide-react";
import { api, fmtDate, fmtTL } from "../../lib/api";
import { Badge } from "../ui/badge";

const RETURN_STATE = {
    requested: { label: "Talep Bekliyor", cls: "border-amber-200 bg-amber-100 text-amber-800" },
    approved: { label: "Onaylandı", cls: "border-emerald-200 bg-emerald-100 text-emerald-800" },
    rejected: { label: "Reddedildi", cls: "border-red-200 bg-red-100 text-red-700" },
};

export default function ReturnsTab() {
    const [returns, setReturns] = useState(null);
    const [filter, setFilter] = useState("all");
    useEffect(() => { api.get("/admin/returns").then((r) => setReturns(r.data)).catch(() => setReturns([])); }, []);

    if (!returns) return <div className="h-48 animate-pulse rounded-2xl bg-muted" />;
    const filtered = returns.filter((r) => filter === "all" || r.return_status === filter);

    return (
        <div data-testid="admin-returns-tab">
            <p className="mb-3 text-sm text-muted-foreground">Alıcıların iade talepleri — onay/red tedarikçi tarafından sipariş detayında yapılır, buradan takip edilir.</p>
            <div className="mb-4 flex flex-wrap items-center gap-2">
                {[["all", "Tümü"], ["requested", "Bekleyen"], ["approved", "Onaylanan"], ["rejected", "Reddedilen"]].map(([v, l]) => (
                    <button key={v} onClick={() => setFilter(v)} className={`rounded-full border px-3.5 py-1.5 text-xs font-medium transition-colors ${filter === v ? "border-primary bg-primary text-primary-foreground" : "hover:border-terra-500/50"}`} data-testid={`returns-filter-${v}`}>{l}</button>
                ))}
                <span className="ml-auto text-xs text-muted-foreground">{filtered.length} kayıt</span>
            </div>
            <div className="overflow-hidden rounded-2xl border bg-card shadow-sm">
                <div className="max-h-[520px] overflow-x-auto overflow-y-auto">
                    <table className="w-full text-sm" data-testid="admin-returns-table">
                        <thead className="sticky top-0 bg-muted/80 backdrop-blur">
                            <tr className="border-b text-left text-xs uppercase tracking-wider text-muted-foreground">
                                <th className="p-3">Sipariş</th><th className="p-3">Taraflar</th><th className="p-3">Tutar</th><th className="p-3">İade Sebebi</th><th className="p-3">Talep Tarihi</th><th className="p-3">Durum</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map((r) => (
                                <tr key={r.order_id} className="border-b last:border-0 hover:bg-muted/40" data-testid={`return-row-${r.order_no}`}>
                                    <td className="p-3 font-mono text-xs font-semibold">{r.order_no}</td>
                                    <td className="p-3 text-xs text-muted-foreground">{r.buyer_company_name} → {r.supplier_name}</td>
                                    <td className="p-3 font-display font-bold text-terra-600">{fmtTL(r.total)}</td>
                                    <td className="p-3 text-xs">
                                        <p className="font-medium">{r.return_reason}</p>
                                        {r.return_note && <p className="text-muted-foreground">{r.return_note}</p>}
                                        {r.return_review_note && <p className="text-muted-foreground italic">Yanıt: {r.return_review_note}</p>}
                                    </td>
                                    <td className="p-3 text-xs text-muted-foreground">{fmtDate(r.return_requested_at)}</td>
                                    <td className="p-3">
                                        <Badge variant="outline" className={`text-[10px] ${RETURN_STATE[r.return_status]?.cls}`} data-testid={`return-state-${r.order_no}`}>{RETURN_STATE[r.return_status]?.label}</Badge>
                                    </td>
                                </tr>
                            ))}
                            {!filtered.length && (
                                <tr><td colSpan={6} className="p-16 text-center text-sm text-muted-foreground" data-testid="returns-empty">
                                    <RotateCcw className="mx-auto mb-3 h-8 w-8 text-muted-foreground" />Bu filtrede iade kaydı yok.
                                </td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
